// styles.ts
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    borderRadius: 4,
    backgroundColor: Colors.White,
    marginTop: 21,
    padding: '24px 36px',
  },
  required: {
    color: Colors.Red,
    marginLeft: 10,
  },
}));

export default useStyles;